import SvgIcon from '@components/SvgIcon';
import styled from 'styled-components';

const IconGroup = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <path
      d="M14 8V5.146q-.028-.036-.069-.077-.041-.04-.077-.069H8a1 1 0 0 1-.894-.553L6.382 3H3.146q-.036.028-.077.069-.04.041-.069.077v9.708q.028.036.069.077.041.04.077.069H7a1 1 0 1 1 0 2H3q-.69 0-1.345-.655T1 13V3q0-.69.655-1.345T3 1h4a1 1 0 0 1 .894.553L8.618 3H14q.69 0 1.345.655T16 5v3a1 1 0 1 1-2 0Zm-1.05 1.733a1 1 0 1 0-2 0v1.121H9.829a1 1 0 1 0 0 2h1.12v1.122a1 1 0 0 0 2 0v-1.122h1.122a1 1 0 1 0 0-2H12.95V9.733Z"
      fillRule="evenodd"
      fill={color}
    />
  ),
})``;

export default IconGroup;
